import { createFileRoute, Link } from '@tanstack/react-router';
import { Group, Stack, Text } from '@mantine/core';
import { motion } from 'framer-motion';
import { Building2, GraduationCap, Users, UsersRound } from 'lucide-react';
import { PageContainer, PageHeader, Section, Card } from '../components/ui';
import { staggerContainer, cardItem } from '../lib/motion';
import { colors } from '../theme/tokens';

export const Route = createFileRoute('/instructor/')({ component: InstructorHome });

const TILES = [
  { to: '/instructor/users', icon: <Users size={18} color={colors.neon} />, title: 'Users',
    description: 'View your organization’s users and invite trainees.' },
  { to: '/instructor/cohorts', icon: <UsersRound size={18} color={colors.hudCyan} />, title: 'Cohorts',
    description: 'Create cohorts and enroll trainees into courses and labs.' },
  { to: '/instructor/organization', icon: <Building2 size={18} color={colors.neon} />, title: 'Organization',
    description: 'Your organization’s details and seat usage.' },
];

function InstructorHome() {
  return (
    <PageContainer size="default">
      <PageHeader icon={GraduationCap} title="Instructor"
        description="Invite trainees, run cohorts, and check your organization." />
      <Section title="Manage your program"
        description="Everything scoped to your own organization.">
        <motion.div variants={staggerContainer} initial="hidden" animate="show"
          style={{ display: 'grid', gap: 16, gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))' }}>
          {TILES.map((t) => (
            <motion.div key={t.to} variants={cardItem}>
              <Link to={t.to} style={{ textDecoration: 'none' }} className="block h-full">
                <Card style={{ cursor: 'pointer', height: '100%' }}>
                  <Stack gap={8}>
                    <Group gap="xs">{t.icon}<Text fw={600}>{t.title}</Text></Group>
                    <Text size="sm" c="dimmed">{t.description}</Text>
                  </Stack>
                </Card>
              </Link>
            </motion.div>
          ))}
        </motion.div>
      </Section>
    </PageContainer>
  );
}
